export default {
  name: 'misc.occupation',
  key: 'occupation',
  attributes: {
    robots: {
      key: 'robots',
      name: 'entity.orbitalRuin.occupation.robots',
    },
    scavengers: {
      key: 'scavengers',
      name: 'entity.orbitalRuin.occupation.scavengers',
    },
    researchers: {
      key: 'researchers',
      name: 'entity.orbitalRuin.occupation.researchers',
    },
    military: {
      key: 'military',
      name: 'entity.orbitalRuin.occupation.military',
    },
    heirs: {
      key: 'heirs',
      name: 'entity.orbitalRuin.occupation.heirs',
    },
  },
};
